import { useCallback, useState } from 'react';

export const useTabContentHeight = () => {
  const [tabHeight, setTabHeight] = useState<string>('auto');

  const onTabContentChange = useCallback((node) => {
    node && setTabHeight(`${node.scrollHeight.toString()}px`);
  }, []);

  return { tabHeight, onTabContentChange };
};
